import { Tooltip, TooltipProps } from '@tableau/widgets';
import React from 'react';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { Messages } from '../../../../codegen/Localize';

const tooltipProps: TooltipProps = {
    getContent: () => <span>{Messages.encryptionTooltip()}</span>
};

export const EncryptionTooltip = (): JSX.Element => {
    /* eslint-disable jsx-a11y/alt-text */
    return (
    <Tooltip {...tooltipProps}>
      <img style={{ minHeight: 15, position: 'relative', top: 3, left: 7}} src={imgPath('data_prep_info.svg')} />
    </Tooltip>
  );
};
